import { render, staticRenderFns } from "./AbsenceMain.vue?vue&type=template&id=9d24cafa&scoped=true&"
import script from "./AbsenceMain.vue?vue&type=script&lang=js&"
export * from "./AbsenceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d24cafa",
  null
  
)

export default component.exports